var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneral({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.2998C8.79442 15.2998 9.84375 14.1922 9.84375 12.8259C9.84375 11.4595 8.79442 10.3519 7.5 10.3519C6.20558 10.3519 5.15625 11.4595 5.15625 12.8259C5.15625 14.1922 6.20558 15.2998 7.5 15.2998Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4844 11.3415C12.0303 11.3405 12.5689 11.4742 13.0572 11.7319C13.5455 11.9896 13.97 12.3642 14.2969 12.8258",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.703125 12.8258C1.02996 12.3642 1.45446 11.9896 1.94277 11.7319C2.43108 11.4742 2.96968 11.3405 3.51562 11.3415",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 17.5264C4.43369 16.8591 4.91372 16.2967 5.51042 15.9033C6.10711 15.51 6.79649 15.3014 7.5 15.3014C8.20351 15.3014 8.89288 15.51 9.48958 15.9033C10.0863 16.2967 10.5663 16.8591 10.875 17.5264",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51558 11.3415C3.1597 11.3419 2.81107 11.2353 2.51043 11.0343C2.20978 10.8333 1.96953 10.5462 1.81775 10.2064C1.66598 9.86665 1.60894 9.48831 1.6533 9.11559C1.69766 8.74288 1.8416 8.39119 2.06828 8.10161C2.29497 7.81204 2.59505 7.59654 2.93345 7.48029C3.27186 7.36405 3.63462 7.35186 3.97934 7.44516C4.32406 7.53845 4.63652 7.73337 4.88019 8.00715C5.12386 8.28092 5.28869 8.62224 5.35542 8.99122",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64453 8.99122C9.71126 8.62224 9.87609 8.28092 10.1198 8.00715C10.3634 7.73337 10.6759 7.53845 11.0206 7.44516C11.3653 7.35186 11.7281 7.36405 12.0665 7.48029C12.4049 7.59654 12.705 7.81204 12.9317 8.10161C13.1584 8.39119 13.3023 8.74288 13.3467 9.11559C13.391 9.48831 13.334 9.86665 13.1822 10.2064C13.0304 10.5462 12.7902 10.8333 12.4895 11.0343C12.1889 11.2353 11.8402 11.3419 11.4844 11.3415",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3516 14.9141C14.5469 14.7344 14.9141 14.3516 14.9141 14.3516L17.0469 14.0469C17.3952 13.4437 17.6631 12.7976 17.8438 12.125L16.5469 10.3984C16.5703 10.1328 16.5469 9.60156 16.5469 9.60156L17.8438 7.875C17.6622 7.20265 17.3944 6.55664 17.0469 5.95312L14.9141 5.64844C14.737 5.45573 14.5495 5.26823 14.3516 5.08594L14.0469 2.95312C13.4437 2.60481 12.7976 2.33692 12.125 2.15625L10.3984 3.45313C10.1333 3.42968 9.86667 3.42968 9.60156 3.45313L7.875 2.15625C7.20265 2.33776 6.55665 2.60561 5.95312 2.95312L5.64844 5.08594C5.45573 5.26823 5.26823 5.45573 5.08594 5.64844L2.95312 5.95312",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.513418ec295c87f770d17ebe1daa250a.svg";
export { ForwardRef as ReactComponent };